import reducer from './synergy-reducer';

export default reducer;
export { initialState } from './synergy-reducer';

export * from './synergy-actions';
